//import Swiper JS
import Swiper, { Navigation, Autoplay} from 'swiper';

Swiper.use([Navigation, Autoplay]);

document.addEventListener("DOMContentLoaded", function() {
    let swiper = new Swiper(".achievementsSwiper", {
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 2500,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});